import * as React from 'react';
import styled from 'styled-components';
import Colours from '../State/Colours';
import devices from '../State/Devices';

const MlrInputLabel = styled.label`
    display: block;
    font-weight: bold;
    margin: 8px 0;
`;

const MlrSelect = styled.select`
    background: transparent;
    border: none;
    font-size: 1em; 
    width: 100%;
    height: 36px;
    max-height: 36px;
    overflow: hidden;
    border: 1px solid ${Colours.inactive};

    &:focus {
        border: 2px solid ${Colours.secondary};
        outline: none;
    }
`;
const MlrFormControl = (props: any) => <div>{props.children}</div>;

const MlrInputComponent = (props: any) => {
    const newProps = {...props};
    const textInput = React.createRef<HTMLInputElement>();
    const onFocus = (e: React.FormEvent<HTMLInputElement>) => {
        if (textInput.current) {
            if (newProps.type === 'number' && textInput.current.value === '0') {
                textInput.current.value = '';
            }
        }
    }

    const onBlur = (e: React.FormEvent<HTMLInputElement>) => {
        if (textInput.current) {
            if (newProps.type === 'number' && textInput.current.value === '') {
                textInput.current.value = '0';
            }
        }
    }

    if (newProps.type === 'number') {
        newProps.min = 0;
    }

    newProps.value = `${newProps.value}`;

    return (
        <input {...newProps} onFocus={onFocus} onBlur={onBlur} ref={textInput} />
    );
};

const MlrInput = styled(MlrInputComponent)`
    font-size: 1em; 
    padding: 8px 16px;
    overflow: hidden;
    box-sizing: border-box;
    border-radius: 4px;
    max-height: 36px;

    opacity: ${({ disabled }) => disabled === true ? 0.5 : 1};
    background-color: ${({ disabled }) => disabled === true ? 'lightgray' : 'white'};
    color: ${({ disabled }) => disabled === true ? 'gray' : Colours.text};
    border: 1px solid ${({ disabled }) => disabled === true ? 'gray' : Colours.gray};

    &:focus {
        border: 1px solid ${Colours.secondary};
        outline: none;
    }

    @media ${devices.laptop} {
        padding: 4px;
    }
`;

const MlrMenuItem = (props: any) => <option {...props}>{props.children}</option>;

export {
    MlrInputLabel as InputLabel,
    MlrSelect as Select,
    MlrFormControl as FormControl,
    MlrInput as Input,
    MlrMenuItem as MenuItem,
}


// WEBPACK FOOTER //
// ./src/Components/MlrForm.tsx